export default __webpack_public_path__ + "static/media/notfound.6744ef96.png";